export default {
  colors: {
    background: '#121212',
    defaultBorder: '#121212',
    lighterBackground: '#000',
    darkerBackground: '#404040',
    backgroundWithOpacity: 'rgba(18, 18, 18, 0.7)',

    primary: {
      dark: '#dff8ff',
      main: '#4aafff',
      light: '#0075b2',
      lighter: '#04044a',
    },

    chart: {
      main: '#4aafff',
    },

    blue: {
      900: '#7ed3ff',
      200: '#1097e5',
      100: '#005481',
      50: '#003250',
    },

    gray: {
      50: '#566a7f',
      75: '#bcbcbc',
      100: '#4d4c4c',
      200: '#E6E6E6',
      201: '#bcbcbc',
      900: '#f1f1f1',
    },

    green: {
      100: '#1f5d3a',
      500: '#7ed2a2',
    },

    orange: {
      100: '#da7c0f',
      500: '#fddcb2',
    },

    danger: {
      dark: '#feb5b5',
      main: '#FC5050',
      light: '#F63131',
    },

    pastelScale: {
      1: '#3ea76a',
      2: '#005481',
      3: '#da7c0f',
      4: 'rgb(223, 90, 73)',
      5: 'rgb(85, 219, 193)',
      6: 'rgb(239, 218, 151)',
      7: 'rgb(223, 148, 138)',
      8: 'rgb(51, 77, 92)',
    }
  },

  filters: {
    primary: 'invert(24%) sepia(58%) saturate(3480%) hue-rotate(183deg) brightness(96%) contrast(101%)',
    oppositeTheme: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(1%) hue-rotate(275deg) brightness(105%) contrast(101%)',
    sameAsTheme: 'brightness(0) saturate(100%) invert(0%) sepia(85%) saturate(7500%) hue-rotate(173deg) brightness(88%) contrast(112%)',
  },
};
